import moment from 'moment';

// The uploaded conversion logfiles usually contain data
// that is X days old. All age calculations are based on this value.
const CONVERSION_DATA_AGE = 3;

export function getConversionDataCutoffDate() {
	// This function determines the most recent day that we have valid
	// conversion data for, based on the following assumptions:
	// 1) Rakuten uploades conversion data every day at 01:00:00 UTC (plus a few seconds)
	// 2) The files get summarized and processed untill 08:00:00 UTC
	// 3) That conversion data DOES NOT include data for the three previous days
	// I.E. the conversion data is AT LEAST 4 days old.

	// So, for any given point in time, we can determine whether or not the conversion data
	// for that day has been uploaded. If so, we know we have up-to-date data for
	// conversions up to (CONVERSION_DATA_AGE) days ago.
	// If not, our conversion data is valid up to (CONVERSION_DATA_AGE - 1) days ago.

	let now = moment.utc();
	let summarizationTime = moment.utc({hour:8, minute:1}).format(); // give the summarization 1 minute of leeway
	let cutoff;
	let daysToRemove;

	if (now.isAfter(summarizationTime)) {
		// Today's conversion data has already been uploaded.
		// Our cutoff day must therefore be TODAY - CONVERSION_DATA_AGE
		daysToRemove = CONVERSION_DATA_AGE;
	} else {
		// Today's conversion data has NOT been uploaded yet.
		// Our cutoff day must be (YESTERDAY - CONVERSION_DATA_AGE)
		// or (TODAY - (CONVERSION_DATA_AGE + 1))
		// This should only happen between 00:00:00 and 08:00:00 UTC
		daysToRemove = CONVERSION_DATA_AGE + 1;
	}

	cutoff = now.subtract(daysToRemove, 'days');

	// With this cutoff, we can now exclude conversion data if
	// it isn't on or before this date.
	return cutoff;
}

export function filterByCutoffDate(objects, cutoffDate) {
	// Filters an array of objects based on a cutoffDate.
	// The objects in the array must have a 'date' property.
	// cutoffDate must be a momentJS datetime.

	return objects.filter(obj => {
        let date = moment.utc(obj.date);
        // check if this date is on or before the cutoff date,
        // with 'day' resolution (i.e. ignore hours, minutes, seconds)
        return date.isSameOrBefore(cutoffDate, 'day');
    });
}
